import { Alert, Button } from 'react-bootstrap';

interface Props {
	loading: boolean;
	error: boolean;
	retry: () => void;
	noDefaults?: boolean;
}

const AiModelsStatus = ({ loading, error, retry, noDefaults }: Props) => {
	if (loading) return <div role="status">Loading AI models…</div>;
	if (!error && !noDefaults) return null;
	return (
		<Alert variant="warning">
			{error
				? 'AI models could not be loaded. Existing selections have not been changed.'
				: 'No default AI models are configured. Ask an administrator to set defaults before adding a chatbox.'}{' '}
			<Button variant="link" onClick={retry}>
				Retry loading AI models
			</Button>
		</Alert>
	);
};

export default AiModelsStatus;
